import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';
import { TrendingUp, Schedule, AttachMoney } from '@mui/icons-material';

const colors = {
  cobaltDeep: '#1a2f6c',
  cobaltBright: '#5a7dff',
  cobaltSky: '#7d9fff',
  cobaltIce: '#b3c9ff',
  midnight: '#0f1a34',
  frost: '#f5f7ff',
};

const ROISection: React.FC = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background: `radial-gradient(circle at 50% 50%, ${colors.cobaltDeep}20 0%, ${colors.midnight} 70%)`,
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2} alignItems="center" textAlign="center" mb={8}>
          <Typography variant="overline" sx={{ color: colors.cobaltBright, fontSize: '0.9rem', letterSpacing: '0.15em' }}>
            증명된 투자 가치
          </Typography>
          <Typography variant="h2" sx={{ color: colors.frost, fontWeight: 700, fontSize: { xs: '2rem', md: '3rem' } }}>
            숫자로 증명합니다
          </Typography>
          <Typography variant="body1" sx={{ color: colors.cobaltIce, maxWidth: '600px', fontSize: '1.1rem', lineHeight: 1.7 }}>
            금형 200개 보유 업체의 실제 도입 사례
          </Typography>
        </Stack>

        {/* ROI Chart Image */}
        <Box
          sx={{
            mb: 8,
            borderRadius: '24px',
            overflow: 'hidden',
            border: `2px solid ${colors.cobaltBright}40`,
            boxShadow: `0 25px 60px ${colors.cobaltBright}30`,
          }}
        >
          <img
            src="/landing/roi-chart.jpg"
            alt="EGMMS ROI Statistics"
            style={{ width: '100%', height: 'auto', display: 'block' }}
          />
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4, justifyContent: 'center' }}>
          {/* 인건비 절감 */}
          <Box sx={{ flex: '0 0 auto', width: { xs: '100%', md: 'calc(33.333% - 21.33px)' } }}>
            <Box
              sx={{
                p: 4,
                borderRadius: '24px',
                background: `linear-gradient(135deg, ${colors.cobaltDeep}30, ${colors.midnight})`,
                backdropFilter: 'blur(20px)',
                border: `2px solid ${colors.cobaltBright}40`,
                textAlign: 'center',
                height: '100%',
              }}
            >
              <Schedule sx={{ fontSize: 48, color: colors.cobaltBright, mb: 2 }} />
              <Typography variant="h3" sx={{ color: colors.cobaltSky, fontWeight: 700, fontSize: '3rem', mb: 1 }}>
                3,672만원
              </Typography>
              <Typography variant="h6" sx={{ color: colors.frost, fontWeight: 600, mb: 1 }}>
                연간 인건비 절감
              </Typography>
              <Typography variant="body2" sx={{ color: colors.cobaltIce }}>
                월 102시간 단축 효과
              </Typography>
            </Box>
          </Box>

          {/* ROI */}
          <Box sx={{ flex: '0 0 auto', width: { xs: '100%', md: 'calc(33.333% - 21.33px)' } }}>
            <Box
              sx={{
                p: 4,
                borderRadius: '24px',
                background: `linear-gradient(135deg, ${colors.cobaltBright}30, ${colors.cobaltDeep}20)`,
                backdropFilter: 'blur(20px)',
                border: `2px solid ${colors.cobaltSky}60`,
                textAlign: 'center',
                height: '100%',
                boxShadow: `0 20px 40px ${colors.cobaltBright}40`,
              }}
            >
              <TrendingUp sx={{ fontSize: 48, color: colors.cobaltBright, mb: 2 }} />
              <Typography variant="h3" sx={{ color: colors.cobaltSky, fontWeight: 700, fontSize: '3rem', mb: 1 }}>
                2,196%
              </Typography>
              <Typography variant="h6" sx={{ color: colors.frost, fontWeight: 600, mb: 1 }}>
                투자 대비 수익률
              </Typography>
              <Typography variant="body2" sx={{ color: colors.cobaltIce }}>
                압도적인 ROI
              </Typography>
            </Box>
          </Box>

          {/* 회수 기간 */}
          <Box sx={{ flex: '0 0 auto', width: { xs: '100%', md: 'calc(33.333% - 21.33px)' } }}>
            <Box
              sx={{
                p: 4,
                borderRadius: '24px',
                background: `linear-gradient(135deg, ${colors.cobaltDeep}30, ${colors.midnight})`,
                backdropFilter: 'blur(20px)',
                border: `2px solid ${colors.cobaltBright}40`,
                textAlign: 'center',
                height: '100%',
              }}
            >
              <AttachMoney sx={{ fontSize: 48, color: colors.cobaltBright, mb: 2 }} />
              <Typography variant="h3" sx={{ color: colors.cobaltSky, fontWeight: 700, fontSize: '3rem', mb: 1 }}>
                3.5개월
              </Typography>
              <Typography variant="h6" sx={{ color: colors.frost, fontWeight: 600, mb: 1 }}>
                투자금 회수 기간
              </Typography>
              <Typography variant="body2" sx={{ color: colors.cobaltIce }}>
                빠른 수익 실현
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ROISection;
